import client from '../httpClient';

const customerGetBrowsingHistoryApi = (pathParams, params) => {
  return client.get(`/customers/list${pathParams || ''}`, JSON.stringify(params));
};

export default customerGetBrowsingHistoryApi;
